


























import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    amount: {
      type: Number,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    monthMode: {
      type: Boolean,
      default: false
    },
    fluidMonthMode: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String as PropType<'blue' | 'tbi' | 'alpha' | 'santander'>,
      required: false,
      default: 'blue'
    }
  },
  setup(props) {
    const { selected, disabled, variant, amount, fluidMonthMode } = toRefs(
      props
    )

    const buttonClasses = computed(() => {
      const c = []
      if (disabled.value) {
        c.push(['tw-opacity-60', 'tw-cursor-not-allowed'])
      }

      if (selected.value) {
        c.push('!tw-cursor-default')

        switch (variant.value) {
          case 'tbi': {
            c.push(['tw-bg-[#FFEDD5]', 'tw-text-tbi', 'tw-border-tbi'])
            break
          }
          case 'alpha': {
            c.push(['tw-bg-[#EBF4FF]', 'tw-text-alpha', 'tw-border-alpha'])
            break
          }
          case 'blue':
          default: {
            c.push(['tw-bg-blue-50', 'tw-text-blue', 'tw-border-blue'])
            break
          }
        }
      } else {
        if (!disabled.value) {
          c.push('hover:tw-bg-grey-100')
        }
        c.push(['tw-bg-grey-150', 'tw-border-grey-150'])
      }

      return c
    })

    const amountToShow = computed(() =>
      fluidMonthMode.value && amount.value >= 12
        ? amount.value / 12
        : amount.value
    )

    return { buttonClasses, amountToShow }
  }
})
